module.exports = __webpack_public_path__ + "media/metronic/_theme/media/blog/blog1-f3ff9f5a905174a9cc40ffa3f7a9226e.jpg";